import { z } from "zod";
import { JsonValue } from "@common/types/json";

export const jsonValueSchema: z.ZodType<JsonValue> = z.lazy(() =>
    z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.null(),
        z.array(jsonValueSchema),
        z.record(jsonValueSchema),
    ]),
);
